export const TOKEN_CURRENT = 'TOKEN_CURRENT'
export const ROLE_ID = 'ROLE_ID'
export const DIGITAL_SIGN = 'DIGITAL_SIGN'
export const EMAIL = 'EMAIL'

export const _ = undefined
